import { render, staticRenderFns } from "./TenantEditDialog.vue?vue&type=template&id=150763c2"
import script from "./TenantEditDialog.vue?vue&type=script&lang=js"
export * from "./TenantEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports